import { useToast } from "@/components/ui/use-toast";
import PromotionalCard from "@/components/dashboard/PromotionalCard";

export const IdCardsPromotional = () => {
  const { toast } = useToast();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
      <PromotionalCard
        title="Digital ID Cards"
        description="Access your insurance ID cards anytime, anywhere. Download them to your phone for easy access."
        icon="star"
        actionLabel="Learn More"
        onClick={() => {
          toast({
            title: "Coming Soon",
            description: "Digital ID card features will be available soon!",
          });
        }}
      />
      <PromotionalCard
        title="Auto-Renewal Reminder"
        description="Never let your insurance lapse. Set up automatic renewal reminders for your policies."
        icon="heart"
        actionLabel="Set Reminder"
        onClick={() => {
          toast({
            title: "Coming Soon",
            description: "Reminder settings will be available soon!",
          });
        }}
      />
      <PromotionalCard
        title="Emergency Support"
        description="24/7 roadside assistance and emergency support. Help is just a tap away."
        icon="gift"
        actionLabel="View Details"
        onClick={() => {
          toast({
            title: "Coming Soon",
            description: "Emergency support features will be available soon!",
          });
        }}
      />
    </div>
  );
};